/* Tostèra – Favorite (boabă de cafea) */
(function () {
  'use strict';

  var STORAGE_KEY = 'tostera:favorites';
  var FAVORITES_URL = '/pages/favorite';

  var BEAN_SVG =
    '<svg class="tostera-bean" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
    '<g transform="rotate(30 12 12)">' +
    '<ellipse class="tostera-bean__body" cx="12" cy="12" rx="6.3" ry="8.7" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
    '<path class="tostera-bean__crease" d="M12 3.8c-3.2 3.1 3.2 8.3 0 16.4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
    '</g></svg>';

  /* ---------- storage ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* privat / storage plin */
    }
  }
  function has(handle) {
    return read().indexOf(handle) !== -1;
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) {
      list.push(handle);
    } else {
      list.splice(i, 1);
    }
    write(list);
    refreshAll();
    return i === -1;
  }

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    var m = (url || '').match(/\/products\/([a-z0-9\-_%]+)/i);
    return m ? decodeURIComponent(m[1]).split('?')[0] : null;
  }
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }
  function makeButton(handle, extraClass) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tostera-fav-btn' + (extraClass ? ' ' + extraClass : '');
    btn.setAttribute('data-tostera-fav', handle);
    btn.innerHTML = BEAN_SVG;
    syncButton(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle(handle);
    });
    return btn;
  }
  function syncButton(btn) {
    var handle = btn.getAttribute('data-tostera-fav');
    var saved = has(handle);
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Elimina din favorite' : 'Adauga la favorite');
    btn.title = saved ? 'Elimină din favorite' : 'Adaugă la favorite';
    var label = btn.querySelector('.tostera-fav-btn__label');
    if (label) {
      label.textContent = saved ? 'Salvat la favorite' : 'Adaugă la favorite';
    }
  }

  /* ---------- carduri de produs ---------- */
  function injectCardButtons(root) {
    var cards = (root || document).querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.querySelector('.tostera-fav-btn')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link ? handleFromUrl(link.getAttribute('href')) : null;
      if (!handle) return;
      var media =
        card.querySelector('.card__media') ||
        card.querySelector('.card__inner') ||
        card;
      media.appendChild(makeButton(handle, 'tostera-fav-btn--card'));
    });
  }

  /* ---------- pagina de produs ---------- */
  function injectProductButton() {
    var form = document.querySelector('.product-form__buttons');
    if (!form || form.parentNode.querySelector('.tostera-fav-btn--product')) return;
    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;
    var btn = makeButton(handle, 'tostera-fav-btn--product');
    var label = document.createElement('span');
    label.className = 'tostera-fav-btn__label';
    btn.appendChild(label);
    syncButton(btn);
    form.parentNode.insertBefore(btn, form.nextSibling);
  }

  /* ---------- iconita in header ---------- */
  function injectHeaderIcon() {
    if (document.querySelector('.tostera-fav-header')) return;
    var cart = document.querySelector('#cart-icon-bubble');
    if (!cart) return;
    var a = document.createElement('a');
    a.href = FAVORITES_URL;
    a.className = 'header__icon header__icon--cart link focus-inset tostera-fav-header';
    a.setAttribute('aria-label', 'Favoritele mele');
    a.innerHTML =
      BEAN_SVG +
      '<div class="cart-count-bubble tostera-fav-header__count" hidden><span aria-hidden="true">0</span></div>';
    cart.parentNode.insertBefore(a, cart);
    refreshHeaderCount();
  }
  function refreshHeaderCount() {
    var bubble = document.querySelector('.tostera-fav-header__count');
    if (!bubble) return;
    var n = read().length;
    bubble.hidden = n === 0;
    var span = bubble.querySelector('span');
    if (span) span.textContent = n > 99 ? '99+' : String(n);
  }

  /* ---------- pagina de favorite ---------- */
  function renderFavoritesPage() {
    var container = document.getElementById('TosteraFavorites');
    if (!container) return;
    var handles = read();
    container.innerHTML = '';

    if (handles.length === 0) {
      container.innerHTML =
        '<div class="tostera-fav-empty">' +
        BEAN_SVG +
        '<p>Nu ai încă produse salvate.</p>' +
        '<p>Apasă pe boaba de cafea de pe orice produs și îl vei regăsi aici.</p>' +
        '<a class="button" href="/collections/all">Descoperă cafelele</a>' +
        '</div>';
      return;
    }

    var grid = document.createElement('div');
    grid.className = 'tostera-fav-grid';
    container.appendChild(grid);

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        })
        .then(function (p) {
          var img = p.featured_image
            ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_400x$1$2')
            : '';
          var card = document.createElement('div');
          card.className = 'tostera-fav-card';
          card.innerHTML =
            '<a class="tostera-fav-card__media" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="tostera-fav-card__info">' +
            '<a class="tostera-fav-card__title" href="' + p.url + '"></a>' +
            '<div class="tostera-fav-card__price">' + formatMoney(p.price) + '</div>' +
            '<div class="tostera-fav-card__actions">' +
            '<button type="button" class="button tostera-fav-card__add"' +
            (p.available ? '' : ' disabled') +
            '>' + (p.available ? 'Adaugă în coș' : 'Stoc epuizat') + '</button>' +
            '<button type="button" class="tostera-fav-card__remove" aria-label="Elimina din favorite">Elimină</button>' +
            '</div></div>';
          card.querySelector('.tostera-fav-card__title').textContent = p.title;
          card.querySelector('.tostera-fav-card__remove').addEventListener('click', function () {
            toggle(handle);
            card.remove();
            if (read().length === 0) renderFavoritesPage();
          });
          if (p.available) {
            card.querySelector('.tostera-fav-card__add').addEventListener('click', function () {
              var b = this;
              b.disabled = true;
              b.textContent = 'Se adaugă...';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
              })
                .then(function (r) { return r.json(); })
                .then(function () {
                  b.textContent = 'Adăugat';
                  window.setTimeout(function () {
                    window.location.href = '/cart';
                  }, 600);
                })
                .catch(function () {
                  b.disabled = false;
                  b.textContent = 'Adaugă în coș';
                });
            });
          }
          grid.appendChild(card);
        })
        .catch(function () {
          var list = read();
          var i = list.indexOf(handle);
          if (i !== -1) {
            list.splice(i, 1);
            write(list);
            refreshHeaderCount();
          }
        });
    });
  }

  /* ---------- sincronizare ---------- */
  function refreshAll() {
    document.querySelectorAll('.tostera-fav-btn').forEach(syncButton);
    refreshHeaderCount();
  }
  function init() {
    injectHeaderIcon();
    injectCardButtons(document);
    injectProductButton();
    renderFavoritesPage();
    refreshAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      injectCardButtons(document);
      injectHeaderIcon();
    }, 200);
  }).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
  document.addEventListener('shopify:section:load', init);
})();
